import React from 'react';
import {useHistory} from 'react-router-dom';
// eslint-disable-next-line wandb/no-deprecated-imports
import {StrictTabProps} from 'semantic-ui-react';

import * as S from './RoutedTab.styles';

type RoutedTabProps = {
  activeTabSlug?: string;
  tabSlugs: string[]; // the first tab's slug is unimportant.
  baseUrl: string;
  style?: Record<string, string>;
};

/**
 * A Tab component where each tab is hooked to its own URL, so you can
 * refresh without losing your tab.
 *
 * The full URL of a tab is {baseUrl / tabSlugs[activeTabSlug]} except
 * for the first tab, which is just {baseUrl}.
 */
const RoutedTabComp: React.FC<RoutedTabProps & StrictTabProps> = ({
  tabSlugs,
  baseUrl,
  activeTabSlug,
  style,
  ...passThroughProps
}) => {
  const history = useHistory();
  // if the URL specifies an invalid tab, just go to baseUrl.
  if (activeTabSlug && !(tabSlugs.indexOf(activeTabSlug) > -1)) {
    history.replace(baseUrl);
  }

  return (
    <S.RoutedTab
      {...passThroughProps}
      style={style}
      className="routed-tab"
      activeIndex={activeTabSlug ? tabSlugs.indexOf(activeTabSlug) : 0}
      onTabChange={
        ((e, {activeIndex}) => {
          if (typeof activeIndex === 'number') {
            history.push(
              baseUrl + (activeIndex === 0 ? '' : '/' + tabSlugs[activeIndex])
            );
          }
        }) as StrictTabProps[`onTabChange`]
      }
    />
  );
};

export const RoutedTab = React.memo(RoutedTabComp);
